import ChooseFigureView from "./view";
import ChooseFigureShowController from "./control/show";
export default function ChooseFigureScreen(element) {
  const view = ChooseFigureView(element);
  const show = ChooseFigureShowController(view);
  return Object.assign(view, {
    show
  });
}